// extracted by mini-css-extract-plugin
export default {"layout":"_6b16bd327a a6e6472524 _00106a35f6","h_slide":"_9b9303b60d","category":"e041598082 b22bb7d23c _5c527d909c"};